export interface CityContactProps {
  email: string;
  phone: string;
}

export class CityContact {
  constructor(readonly email: string, readonly phone: string) {}

  static create(props: CityContactProps) {
    return new CityContact(props.email, props.phone);
  }

  static createEmpty() {
    return this.create({
      email: "",
      phone: "",
    });
  }

  isEmpty() {
    return !this.email && !this.phone;
  }

  isSameTo(otherProps: CityContactProps) {
    return this.email === otherProps.email && this.phone === otherProps.phone;
  }
}
